export function PortraitTeaserCard() {
  return (
    <section className="mt-4 rounded-xl border border-[var(--color-divider)] bg-white/60 p-4 text-center shadow-sm backdrop-blur-sm">
      <p className="text-base font-semibold text-[var(--color-text-primary)]">
        Make this picture yours ✨
      </p>
      <p className="mt-2 text-sm text-[var(--color-text-secondary)]">
        Upload a photo of your dog and we&apos;ll create a personalised version of this artwork.
      </p>
      <p className="mt-2 text-sm font-medium text-[var(--color-text-primary)]">
        Included free with every account.
      </p>
    </section>
  )
}
